import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import scrollToTop from '../helpers/scrollToTop';
import reservation from '../images/reservation.jpg';

function ReservationSuccess() {
  useEffect(() => {
    scrollToTop();
  }, []);

  const pageVariants = {
    initial: { opacity: 0, y: 50 },
    in: { opacity: 1, y: 0 },
    out: { opacity: 0, y: -50 },
  };

  const pageTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.5,
  };

  return (
    <motion.div
      className="min-h-screen flex flex-col"
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <div className="relative">
        <img
          className="brightness-75 grayscale object-cover h-[40vh] object-center w-full"
          src={reservation}
          alt="Фон за потвърждение на резервация"
        />
        <h2 className="absolute h-full top-0 flex items-center left-1/2 -translate-x-1/2 text-center py-4 text-5xl md:text-6xl text-red-800">
          Резервацията е потвърдена
        </h2>
      </div>

      <section className="flex-1 max-w-4xl mx-auto w-full px-4 py-8">
        <div className="bg-white border border-red-800 rounded-2xl shadow-xl p-6 md:p-8 text-center text-red-800">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">Благодарим ви!</h3>
          <p className="text-xl md:text-2xl mb-6">
            Успешно записахме вашата резервация. Ще ви очакваме в избрания час.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="border border-red-800 text-red-800 px-6 py-3 rounded-lg shadow-lg hover:bg-red-800 hover:text-white transition duration-300"
            >
              Към началото
            </Link>
          </div>
        </div>
      </section>
    </motion.div>
  );
}

export default ReservationSuccess;
